<template>
                         <div >
                            <h1>交易紀錄</h1><!--目前所在頁面標題-->
                            <section class="transaction_list">
                                <ul>
                                    <li  v-for = "transactionData in transactionDatas">

                                        <div v-if="transactionData.order_type=='1'">
                                        <h2>加值點數 {{transactionData.points}}點</h2>
                                        <b>{{convertUTCTimeToLocalTime(transactionData.created_at)}}</b>
                                         <i  v-if="transactionData.statusCode != null && transactionData.statusCode== '1000' " >訂單編號：{{transactionData.orderNumber}}</i>
                                         <i>付款編號：{{transactionData.transactionId}}</i>

                                            <div v-if="transactionData.statusCode != null && transactionData.statusCode== '1000' " class="status">
                                                <b >交易成功</b>
                                                 <p>+<strong>{{transactionData.points }}點</strong></p>
                                            </div>

                                            <div v-else class="status failed">
                                                <b >交易失敗</b>
                                                 <em>請至APP更新交易狀態</em>
                                            </div>
                                        </div>

                                        <div v-else>

                                            <h2>{{transactionData.channel.title}}</h2>
                                            <b>{{convertUTCTimeToLocalTime(transactionData.created_at)}}</b>
                                            <i>兌換編號：{{transactionData.orderNumber}}</i>
                                                <div v-if="transactionData.statusCode != null && transactionData.statusCode== '7000' " class="status">
                                                    <b>兌換成功</b>
                                                    <p>-<strong>{{transactionData.points}}點</strong></p>
                                                </div>

                                                <div v-else class="status failed">
                                                    <b>兌換失敗</b>
                                                    <p>-<strong>{{transactionData.points}}點</strong></p>
                                                    <em>請至APP更新交易狀態</em>
                                                </div>
                                        </div>
                                    </li>  



                                    <!-- <li>
                                        <h2>紅樓夢非關愛情 - 大觀園的成長儀式</h2>
                                        <b>2018/05/25 13:11:31</b>
                                        <i>兌換編號：AB37928437298</i>
                                        <div class="status">
                                            <b>兌換成功</b>
                                            <p>-<strong>60點</strong></p>
                                        </div>
                                    </li>
                                    <li>
                                        <h2>掌握管理的情境</h2>
                                        <b>2018/05/25 13:11:31</b>
                                        <i>兌換編號：AB37928437298</i>
                                        <div class="status failed">
                                            <b>兌換失敗</b>
                                            <p>-<strong>60點</strong></p>
                                            <em>請至APP更新交易狀態</em>
                                        </div>
                                    </li>
                                    <li>
                                        <h2>加值點數 60點</h2>
                                        <b>2018/05/25 13:11:31</b>
                                        <i>訂單編號：AB37928437298</i>
                                        <i>付款編號：B437298</i>
                                        <div class="status">
                                            <b>交易成功</b>
                                            <p>+<strong>60點</strong></p>
                                        </div>
                                    </li>
                                    <li>
                                        <h2>加值點數 60點</h2>
                                        <b>2018/05/25 13:11:31</b>
                                        <i>訂單編號：AB37928437298</i>
                                        <i>付款編號：B437298</i>
                                        <div class="status failed">
                                            <b>交易失敗</b>
                                            <em>請至APP更新交易狀態</em>
                                        </div>
                                    </li> -->
                                    
                                    
                                </ul>
                            </section>

                            <section class="emptyPage" v-if="transactionDatas.length == 0">
                                <div class="wrap">
                                    <figure>
                                        <img src="@/assets/images/status_empty_transaction.png" alt="沒有任何交易紀錄">
                                        <figcaption>
                                            您目前沒有任何紀錄
                                        </figcaption>
                                    </figure>
                                </div>
                            </section>
                            
                        </div>
                 
         
</template>

<script>
import { mapGetters } from "vuex";

export default {
         name: 'async',
    metaInfo () {
      return {
        
        title: '交易紀錄 | 我的 | 一刻鯨選',
        meta: [
            // OpenGraph data (Most widely used)
            {property: 'og:title', content: '交易紀錄 | 我的 | 一刻鯨選'},
            {property: 'og:site_name', content: '交易紀錄 | 我的 | 一刻鯨選'},
            // The list of types is available here: http://ogp.me/#types
            {property: 'og:type', content: 'website'},
            // Should the the same as your canonical link, see below.
            {property: 'og:url', content: window.location.toString()},
            {property: 'og:image', content: this.$store.state.urlDomain+'/static/logo.jpg'},
            // Often the same as your meta description, but not always.
            {property: 'og:description', content: '登入後，即可查看帳戶所有資訊。'},
        
        ]
      }
    },
data() {
        return {
            transactionDatas:[],
        }
     },
     computed: {
    ...mapGetters(["userInfo,credentialToken"])
    
  },

  created() {
    this.axios
       .get(this.$store.getters.baseURL + 'orders', { headers: {"Authorization" : `Bearer ${localStorage.getItem('credentialToken')}`} })
      .then(response => {
          this.transactionDatas = response.data

      })
      .catch(error => console.log("log:"+error));
  },
   methods:{
      convertUTCTimeToLocalTime: function (UTCDateString) {
        if(!UTCDateString){
          return '-';
        }
        function formatFunc(str) {    //格式化显示
          return str > 9 ? str : '0' + str
        }
        var date2 = new Date(UTCDateString);     //这步是关键
        var year = date2.getFullYear();
        var mon = formatFunc(date2.getMonth() + 1);
        var day = formatFunc(date2.getDate());
        var hour = date2.getHours();
     //   var noon = hour >= 12 ? 'PM' : 'AM';
       // hour = hour>=12?hour-12:hour;
       // hour = formatFunc(hour);
        var min = formatFunc(date2.getMinutes());
        var sec = formatFunc(date2.getSeconds());

        var dateStr = year+'-'+mon+'-'+day+' '+hour+':'+min+':'+sec;
        return dateStr;
      }
   }
};
</script>

<style>

@import '../../../assets/css/user.css';
@import '../../../assets/css/user_rwd.css';
 body {padding-top: 0;}
 /* body {padding-top: 0;}
 .bodyHeader {display: none;} */
</style>



// WEBPACK FOOTER //
// src/components/views/mySubviews/MyTransaction.vue